import React from 'react';
import { Box, Stack, Typography, Button, Grow, Card, Fade } from '@mui/material';
import { Icon } from '@iconify/react';
import arrowCircleRightFill from '@iconify/icons-eva/arrow-circle-right-fill';
import bookOpenFill from '@iconify/icons-eva/book-open-fill';
import messageCircleFill from '@iconify/icons-eva/message-circle-fill';
import { useTheme, styled } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
import jwt from 'jsonwebtoken';
import * as Scroll from 'react-scroll';

const { Link } = Scroll;

export default function Footer({ user }) {
  const theme = useTheme();
  const StyledFont = styled(Typography)`
    color: ${theme.palette.text.primary};
    &:hover {
      color: ${theme.palette.primary.main};
    }
    &:focus {
      color: ${theme.palette.primary.main};
    }
  `;

  const openLink = (link) => {
    if (!link || link === '#') return;
    window.open(link, '_blank');
  };

  function FontLink({ id, label, link }) {
    return (
      <StyledFont>
        <Typography onClick={() => openLink(link)} sx={{ cursor: 'pointer' }} variant="caption">
          {label}
        </Typography>
      </StyledFont>
    );
  }

  const links = [
    { id: 'rekomendasi', label: 'Rekomendasi' },
    { id: 'subdomain', label: 'Subdomain' },
    { id: 'hosting', label: 'Hosting' },
    { id: 'tte', label: 'Tanda Tangan Elektronik' },
    { id: 'cloudstorage', label: 'Cloud Storage' }
  ];
  return (
    <Fade in="true" timeout={1500}>
      <Stack
        direction="row"
        p={5}
        spacing={2}
        sx={{
          justifyContent: 'space-around',
          alignItems: 'flex-start',
          bottom: 0,
          boxShadow: 0,
          borderRadius: 0,
          height: 'auto',
          bgcolor: 'grey.200',
          display: 'flex',
          minWidth: '100vw'
        }}
      >
        <Stack direction="column" spacing={1}>
          <Typography variant="subtitle2">Tentang</Typography>
          <FontLink
            label="PELADEN"
            id="peladen"
            link="https://wiki.jogjaprov.go.id/diskominfo/manual-peladen"
          />
        </Stack>
        <Stack direction="column" spacing={1}>
          <Typography variant="subtitle2">Layanan</Typography>
          {links.map((item) => (
            <Link
              to={item.id}
              spy="true"
              smooth="true"
              duration={500}
              className="some-class"
              activeClass="some-active-class"
            >
              <FontLink key={item.id} label={item.label} id={item.id} link="#" />
            </Link>
          ))}
        </Stack>
        <Stack direction="column" spacing={1}>
          <Typography variant="subtitle2">Kontak Kami</Typography>
          <FontLink
            label="Helpdesk"
            id="discord"
            link="https://wa.me/6282133576291?text=Hello Diskominfo DIY..."
          />
          <FontLink label="Email" id="email" link="mailto:kamisandi@jogjaprov.go.id" />
          <FontLink label="Tel: (0274) 373444" id="telephone" link="tel:(0274) 373444" />
        </Stack>
        <Stack direction="column" spacing={1}>
          <Typography variant="subtitle2">Sosial Media</Typography>
          <FontLink label="Website" id="website" link="https://diskominfo.jogjaprov.go.id" />
          <FontLink label="Instagram" id="instagram" link="https://www.instagram.com/kominfodiy/" />
        </Stack>
      </Stack>
    </Fade>
  );
}
